import {observer} from "mobx-react-lite";
import {FormControl, IconButton, Input, InputAdornment, InputLabel} from "@mui/material";
import {Clear} from "@mui/icons-material";
import React from "react";
import {useStores} from "../../../stores";

export const SpendConcentrationSearchComponent = observer(() => {
    const {spendConcentrationStore} = useStores();
    const filterController = spendConcentrationStore.sCPageController.filterController;

    return <FormControl variant="standard" fullWidth={true} className="search-field">
        <InputLabel htmlFor="supplier-search-field">
            Vendor search
        </InputLabel>
        <Input
            id="supplier-search-field"
            type="text"
            fullWidth={true}
            endAdornment={
                <InputAdornment position="end">
                    <IconButton
                        aria-label="clear search"
                        onClick={() => filterController.setSupplierSearch('')}
                    >
                        <Clear/>
                    </IconButton>
                </InputAdornment>
            }
            value={filterController.supplierSearchValue}
            onChange={e => {
                filterController.setSupplierSearch(e.target.value);
            }}
        />
    </FormControl>
})